import React from "react";
import { Row } from "react-bootstrap";

function Mision() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "10px" }}>
        <strong className="purple">Misión</strong>
      </h1>
      <p className="home-about-body">
      Queremos mantener una relación de confianza
        y apoyo con nuestros clientes innovando
        constantemente a la par de la tecnología y los
        cambios fiscales.
      </p>
    </Row>
  );
}

export default Mision;
